import { CircleAlert } from "lucide-react";
import { Link } from "react-router-dom";

export function ErrorState({ message }: { message: string }) {
  return (
    <div className="mx-auto my-20 max-w-xl rounded-[2rem] border border-coral/30 bg-white p-8 text-center shadow-soft">
      <CircleAlert className="mx-auto text-coral" size={38} />
      <h2 className="mt-4 font-display text-3xl">We hit a detour.</h2>
      <p className="mt-3 text-ink/65">{message}</p>
      <Link className="btn-dark mt-6 inline-flex" to="/assessment">Try the assessment again</Link>
    </div>
  );
}
